<template>
    <div class="event-ticket--edit-mode">
        <div v-if="methods_available.createTicketTypeRestriction(current_ticket.ticket_type)"
             class="alert alert-warning alert-dismissible fade show" role="alert">
            <div><strong>Disabled attributes will effect all uses of this ticket on
                other event</strong> Name, Price, Allocations must be edited
                globally. All global changes will update this
                {{current_ticket.ticket_type}} ticket for all events
            </div>
            <button class="mt-0 btn-accent btn-floating waves-effect"
                    v-on:click="methods_available.ultraEditTicket()">
                <i class="fa fa-cog"></i></button>
        </div>
        <div v-if="is_bundle_child"
             class="alert alert-danger ade show" role="alert">
            <div>
                <strong>This is a Child of a bundled ticket</strong>
                <p>
                    Price, Allocations and status cannot be changed.
                </p>
            </div>
        </div>
        <div class="col d-md-flex justify-content-between">
            <!--title-->
            <div class="w-100 w-md-20">
                <div class="md-form">
                    <input v-model="current_ticket.ticket_data.lang[lang].title"
                           type="text"
                           :id="'title-' + current_ticket.id" class="form-control">
                    <label class="active"
                           :for="'title-' + current_ticket.id">Ticket Name</label>
                </div>
            </div>
            <!--price-->
            <div class="">
                <div class="md-form">
                    <input v-model="current_ticket.edit_price"
                           @change="methods_available.readPrice(current_ticket,'price-' + current_ticket.id)"
                           type="number"
                           :id="'price-' + current_ticket.id"
                           :disabled="is_bundle_child"
                           class="form-control"
                        :class="{
                                   // disable price is this is a child because prices are defined by the parent
                                   'disabled':is_bundle_child
                        }"
                    >
                    <input type="hidden" v-if="is_bundle_child" :value="current_ticket.edit_price">
                    <label class="active"
                           :for="'price-' + current_ticket.id">Price</label>
                </div>
            </div>
            <!--allocation-->
            <div class="">
                <div class="md-form">
                    <input v-model="current_ticket.allocated" type="number"
                           :id="'allocated-' + current_ticket.id"
                           :min="methods_available.getValidSales(current_ticket).length"
                           class="form-control"
                           :disabled="is_bundle_child"
                           :class="{
                                   'disabled':is_bundle_child
                        }"
                    >
                    <input type="hidden" v-if="is_bundle_child" :value="current_ticket.allocated">
                    <label class="active"
                           :for="'allocated-' + current_ticket.id">Allocated</label>
                </div>
            </div>
            <!--active-->
            <div class="pseudo-form md-form w-100 w-md-20">
                <div class="pseudo-form--input border-0">
                    <div class="switch">
                        <label>
                            Off
                            <input type="checkbox"
                                   :checked="methods_available.isActiveCheck(current_ticket)"
                                   @change="methods_available.toggleActive(current_ticket)"
                                   :disabled="is_bundle_child"
                                   :class="{
                                   'disabled':is_bundle_child
                        }"
                            >

                            <span class="lever"></span>
                            On
                        </label>
                        <input type="hidden" v-if="is_bundle_child" :value="methods_available.isActiveCheck(current_ticket)">
                    </div>
                </div>
                <div class="pseudo-form--label active">
                    <i class="fa align-0"
                       :class="{
                         'fa-check-circle': methods_available.isActiveCheck(current_ticket)==='checked',
                         'fa-circle-o': methods_available.isActiveCheck(current_ticket)!=='checked'
                       }"></i> Status
                </div>
            </div>

        </div>

        <event-ticket--attributes
                v-if="show_ticket_attributes"
                :current_ticket="current_ticket"
                :add_time_slot="add_time_slot"
                :urls="urls"
                @event_ticket_attributes__event="parseTicketAttr"
                :loading="loading"
                :lang="lang"
                :methods_available="methods_available"
                @event="EventHandler"
        ></event-ticket--attributes>

        <!--save and cancel buttons-->
        <div class="flex-row">
            <a class="btn btn-primary waves-effect waves-light"
               v-on:click="save()">Save</a>

            <a v-on:click="reset()"
               class="btn btn-secondary waves-effect waves-light">Cancel</a>
        </div>
    </div>
</template>

<script>
	import {_} from 'underscore';

	Vue.component(
		'event-ticket--attributes',
		require('./EventTicketAttributes.vue')
	);
	export default {
		name: "event-ticket-mode-edit",
		props: [
			'current_ticket',
			'ticket',
			'lang',
			'methods_available',
			'editing_attributes',
			'add_time_slot',
			'loading',
			'urls',
			'index',
		],
		data() {
			return {
			    show_ticket_attributes:false
            }
		},
		mounted() {

		},
        computed:{
		    is_bundle_parent(){
		        return this.current_ticket.is_bundle > 0 &&  this.current_ticket.is_bundle < 2;
            },
            is_bundle_child(){
                return this.current_ticket.is_bundle > 1;
            }
        },
		watch: {

        },
		methods: {
			EventHandler(params) {
				// console.log('EventHandler', 'params',params);
				switch (params.action) {
					case 'event_ticket_attributes__open_close_full':
						// console.log('EventHandler received from attribute time change', 'params',params);
						// don't know why but this doesnt reach the parent of parent so im parsing to the event ticket edit mode vue
						this.$emit('event', {
							action: 'event_ticket_attributes__open_close_full',
							items: {
								value: params.items.value
							}
						});
						break;
				}
			},
			parseTicketAttr() {
				console.log('hi');
			},
			save() {
				this.$emit('event', {
					action: 'editing_attributes',
					items: {
						value: false
					}
				});
				this.$emit('event', {
					action: 'edit_ticket',
					items: {
						ticket: this.ticket
					}
				});
				// this.methods_available.editTicket(this.ticket, 'item-' + this.ticket.id);
			},
			reset() {
				this.$emit('event', {
					action: 'editing_attributes',
					items: {
						value: false
					}
				});
				this.$emit('event', {
					action: 'reset_form',
					items: {
						ticket: this.ticket
					}
				});
				// this.methods_available.resetForm(this.ticket)
			}
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/pages/ticketing/EventTicketModeEdit.vue?99f5c28e